module.exports = __webpack_public_path__ + "img/logo-reversed.3fccafff.svg";